import script from "./CompareThreshold.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareThreshold.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__